import { Info } from "lucide-react";

export function Disclaimer() {
  return (
    <p className="disclaimer">
      <Info aria-hidden="true" />
      <span>
        AI vizualizacija predstavlja prijedlog izgleda. Proizvodi ispod vizualno su slične opcije dostupne u
        trgovinama.
      </span>
    </p>
  );
}
